"use client";

import { Eye, Instagram, Plus, RotateCcw, Trash2 } from 'lucide-react';

export default function InstagramActionButtons({
  hasPost,
  disabled,
  publishing,
  canDiscardFailure,
  discarding,
  onView,
  onPost,
  onDelete,
  onDiscardFailure,
}: {
  hasPost: boolean;
  disabled?: boolean;
  publishing?: boolean;
  canDiscardFailure?: boolean;
  discarding?: boolean;
  onView: () => void;
  onPost: () => void;
  onDelete: () => void;
  onDiscardFailure?: () => void;
}) {
  const inactive = disabled || !hasPost;
  const postDisabled = disabled || hasPost || publishing;
  const discardDisabled = disabled || !canDiscardFailure || discarding;
  return (
    <div className="inline-flex items-center gap-1 rounded-md border border-pink-100 bg-pink-50/60 px-1.5 py-1">
      <Instagram className="h-3.5 w-3.5 text-pink-600" />
      <button
        type="button"
        disabled={postDisabled}
        onClick={onPost}
        title={hasPost ? 'Instagram post already exists' : 'Post to Instagram'}
        className="h-7 w-7 rounded-md border border-pink-200 bg-white text-pink-700 shadow-sm flex items-center justify-center hover:bg-pink-50 disabled:opacity-45 disabled:pointer-events-none"
      >
        <Plus className={`h-3.5 w-3.5 ${publishing ? 'animate-pulse' : ''}`} />
      </button>
      <button
        type="button"
        disabled={inactive}
        onClick={onView}
        title={hasPost ? 'View Instagram post' : 'No Instagram post'}
        className="h-7 w-7 rounded-md border border-pink-200 bg-white text-pink-700 shadow-sm flex items-center justify-center hover:bg-pink-50 disabled:opacity-45 disabled:pointer-events-none"
      >
        <Eye className="h-3.5 w-3.5" />
      </button>
      <button
        type="button"
        disabled={inactive}
        onClick={onDelete}
        title={hasPost ? 'Delete Instagram post' : 'No Instagram post'}
        className="h-7 w-7 rounded-md border border-red-200 bg-white text-red-700 shadow-sm flex items-center justify-center hover:bg-red-50 disabled:opacity-45 disabled:pointer-events-none"
      >
        <Trash2 className="h-3.5 w-3.5" />
      </button>
      {canDiscardFailure ? (
        <button
          type="button"
          disabled={discardDisabled}
          onClick={onDiscardFailure}
          title="Discard failed Instagram post"
          className="inline-flex h-7 items-center gap-1 rounded-md border border-red-200 bg-white px-2 text-[11px] font-semibold text-red-700 shadow-sm hover:bg-red-50 disabled:opacity-45 disabled:pointer-events-none"
        >
          <RotateCcw className={`h-3.5 w-3.5 ${discarding ? 'animate-spin' : ''}`} />
          Discard
        </button>
      ) : null}
    </div>
  );
}
